import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { TypeSadpath } from '../../../enums/type-sadpath';

@Component({
  selector: 'app-sadpath',
  imports: [TranslateModule, MatIconModule],
  templateUrl: './sadpath.component.html',
  styleUrl: './sadpath.component.scss',
})
export class SadpathComponent {
  @Input() type: TypeSadpath = TypeSadpath.TEXT;
  noLengthSadPath = TypeSadpath.LENGTH;
  noTextSadPath = TypeSadpath.TEXT;
}
